var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_620_37513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.2863 17.1428H5.71484V62.8571H74.2863V17.1428Z",
    fill: "#166DD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71484 17.1428H74.2863L40.0006 40L5.71484 17.1428Z",
    fill: "#ADCCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2863 62.8571V17.1428L5.71484 62.8571H74.2863Z",
    fill: "#0B3E91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_620_37513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.5714,
    height: 45.7143,
    fill: "white",
    transform: "translate(5.71484 17.1428)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.9ab3892a7c8df21edca5fc23bb2487fb.svg";
export { ForwardRef as ReactComponent };